import { CtaSidebarProps } from '@/components/_blog-updates/CtaSidebar';
import { CraftCtaSidebarData } from './CraftCtaSidebar.types';

const VALID_THEMES = ['citron', 'light', 'noContainer', 'imageThumbnail'] as const;

type ValidTheme = (typeof VALID_THEMES)[number];

const isValidTheme = (value: string): value is ValidTheme => VALID_THEMES.includes(value as ValidTheme);

export const mapBlockToCtaSidebarProps = (block: CraftCtaSidebarData | null | undefined): CtaSidebarProps => {
  const themeRaw = block?.ctaSidebarBlockTheme ?? '';
  const theme: CtaSidebarProps['theme'] = isValidTheme(themeRaw) ? themeRaw : 'citron';
  const image = block?.ctaSidebarBlockImage?.[0];

  return {
    theme,
    title: block?.ctaSidebarBlockTitle ?? '',
    description: block?.ctaSidebarBlockDescription ?? undefined,
    image: image?.url,
    showAvatars: !!block?.ctaSidebarBlockShowAvatars,
    hasEmailCapture: !!block?.ctaSidebarBlockEmailCapture,
  };
};
